import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../../app/i18n";
import { SitesPage } from "../../../../areas/seller/sites/SitesPage";
import type { BillingFilter } from "../../../../areas/seller/sites/SitesPage";

/** Kept here (not imported) so validating the URL does not pull the screen into the entry chunk. */
const BILLING_FILTERS = [
  "preview",
  "active",
  "late",
  "suspended",
  "cancelled",
] as const satisfies readonly BillingFilter[];

interface SitesSearch {
  state?: BillingFilter;
}

export const Route = createFileRoute("/app/_seller/sites/")({
  validateSearch: (search: Record<string, unknown>): SitesSearch =>
    (BILLING_FILTERS as readonly unknown[]).includes(search.state)
      ? { state: search.state as BillingFilter }
      : {},
  beforeLoad: () => loadNamespaces("sites"),
  component: SitesPage,
});
